import React from "react";

function KofiButton() {
	return (
    <a
      href='https://ko-fi.com/T6T8AP2H6'
      target='_blank'
			rel="noopener noreferrer"
			style={{marginTop: 8}}
    >
      <img
        height={36}
        style={{border:0, height:36}}
        src='https://cdn.ko-fi.com/cdn/kofi2.png?v=3'
        border='0'
        alt='Buy Me a Coffee at ko-fi.com'
      />
    </a>
	);
}

export default KofiButton;
